import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-20 border-t border-[hsl(var(--border))] bg-[hsl(var(--muted))]/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="font-serif text-2xl mb-2">Candle Co.</div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Light up your little moments — handpoured with warmth, made to make everyday feel special.
          </p>
          <div className="flex gap-3 mt-5">
            <a href="#" className="p-2 rounded-full border border-[hsl(var(--border))] hover:bg-[hsl(var(--background))] transition"><Instagram className="w-4 h-4" /></a>
            <a href="#" className="p-2 rounded-full border border-[hsl(var(--border))] hover:bg-[hsl(var(--background))] transition"><Facebook className="w-4 h-4" /></a>
            <a href="#" className="p-2 rounded-full border border-[hsl(var(--border))] hover:bg-[hsl(var(--background))] transition"><Twitter className="w-4 h-4" /></a>
          </div>
        </div>
        <div>
          <div className="font-medium mb-3">Shop</div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/shop" className="hover:text-foreground">All Candles</Link></li>
            <li><Link to="/shop?category=luxury" className="hover:text-foreground">Luxury Collection</Link></li>
            <li><Link to="/shop?category=gift-sets" className="hover:text-foreground">Gift Sets</Link></li>
            <li><Link to="/offers" className="hover:text-foreground">Special Offers</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-medium mb-3">Company</div>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/about" className="hover:text-foreground">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-foreground">Contact</Link></li>
            <li><a href="#" className="hover:text-foreground">Shipping Policy</a></li>
            <li><a href="#" className="hover:text-foreground">Returns</a></li>
          </ul>
        </div>
        <div>
          <div className="font-medium mb-3">Stay in the glow</div>
          <p className="text-sm text-muted-foreground mb-3">Subscribe for scent stories and 10% off your first order.</p>
          <form onSubmit={(e) => e.preventDefault()} className="flex gap-2">
            <input data-testid="newsletter-input" type="email" placeholder="Your email"
              className="flex-1 px-3 py-2 rounded-md border border-[hsl(var(--border))] bg-[hsl(var(--background))] text-sm" />
            <button data-testid="newsletter-submit" className="px-4 py-2 rounded-md bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] text-sm font-medium">Join</button>
          </form>
        </div>
      </div>
      <div className="border-t border-[hsl(var(--border))] py-5 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Candle Co. — Handpoured with love. All rights reserved.
      </div>
    </footer>
  );
}
